import React from 'react';
import { useLocation } from 'wouter';
import { motion, AnimatePresence } from 'framer-motion';

type PageTransitionProps = {
  children: React.ReactNode;
};

/**
 * Smooth page transition wrapper.
 * Uses Framer Motion for fade animations between routes.
 * Suspense handles actual loading - no artificial delays.
 */
export default function PageTransition({ children }: PageTransitionProps) {
  const [location] = useLocation();
  
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location}
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -8 }}
        transition={{ duration: 0.2, ease: 'easeOut' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}